import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dynamic-signature-modal',
  templateUrl: './dynamic-signature-modal.component.html',
  styleUrls: ['./dynamic-signature-modal.component.scss']
})
export class DynamicSignatureModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<DynamicSignatureModalComponent>,
    @Inject(MAT_DIALOG_DATA) public operations: { operationType: string, order: number }[]) { }

  ngOnInit(): void {
    this.operations.sort((a, b) => a.order - b.order);
  }

  selectOperationType(operationType: string): void {
    this.dialogRef.close({ success: true, operationType })
  }

}
